import React from "react";

/** Shared "Show more" expander for long dashboard lists (Phase 6). */
export function ShowMore({ shown, total, onMore, testId }) {
  if (shown >= total) return null;
  return (
    <div className="flex justify-center mt-4">
      <button
        data-testid={testId}
        onClick={onMore}
        className="text-sm text-forest border border-forest/20 rounded-full px-5 py-2 hover:bg-forest/5 transition-colors"
      >
        Show more ({total - shown} more)
      </button>
    </div>
  );
}
